























import Vue from 'vue';
import StudioProduct from '@/web/views/shop/StudioProduct';
import StudioPurchaseToolbar from '@/web/views/shop/StudioPurchaseToolbar';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'StudioBundledProduct',
  components: {
    StudioProduct,
    StudioPurchaseToolbar,
  },
  data() {
    return {
      review: true,
      isPurchasing: false,
      showFullActions: true,
      isLoading: false,
      bundle: {},
    };
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  async mounted() {
    this.loadBundle();
  },
  methods: {
    async loadBundle() {
      try {
        this.isLoading = true;
        this.bundle = await this.$store.dispatch('product/fetchProductDetail', {
          studioURL: this.studioURL,
          productId: this.$route.params.bundle_id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load product',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
});
